import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'xlog-login',
    templateUrl: 'maintenance.component.pug',
    styleUrls: ['maintenance.component.scss'],
    standalone: false
})
export class MaintenanceComponent implements OnInit {

    loaded = false;

    constructor() {}

    ngOnInit() {
        this.loaded = true;
    }
}
